<template>
  <div :class="['the-header', { shadow: !isTop }]">
    <div class="main-logo">
      <span class="main-logo-part">Math</span>
      <span class="main-logo-part">Test</span>
      <span class="main-logo-part">Ninja</span>
    </div>
    <MenuButton @click="toggleNav" class="menu-button" />
    <nav :class="{ show: showNav }">
      <RouterLink
        v-for="link in navLinks"
        :key="link.title"
        :to="link.path"
        :class="['header-link', { active: isLinkActive(link) }]"
      >
        {{ link.title }}
      </RouterLink>
      <a href="https://app.mathtest.ninja/daily" target="blank" class="header-link"> Demo </a>
      <a href="https://app.mathtest.ninja/sign-up" id="login-signup-link"> Login / Sign up </a>
    </nav>
  </div>
</template>

<script>
import MenuButton from './menu-button'
export default {
  name: 'TheHeader',
  components: {
    MenuButton,
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.isTop = window.scrollY === 0
    })
  },
  data() {
    return {
      showNav: false,
      navLinks: [
        {
          path: '/',
          title: 'Home',
        },
        {
          path: '/our-approach',
          title: 'Our Approach',
        },
        {
          path: '/plans',
          title: 'Plans & Pricing',
        },
      ],
      isTop: null,
    }
  },
  methods: {
    isLinkActive({ path }) {
      return this.$route.path === path
    },
    toggleNav() {
      this.showNav = !this.showNav
    },
  },
  watch: {
    $route() {
      this.showNav = false
    },
  },
}
</script>

<style lang="scss" scoped>
.main-logo-part {
  &:nth-of-type(1) {
    color: gray;
  }
  &:nth-of-type(2) {
    color: #484848;
  }
  &:nth-of-type(3) {
    color: $color-primary-2;
  }
}

.menu-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  @media (min-width: $screen-tablet) {
    display: none;
  }
}

nav {
  text-align: center;
  position: fixed;
  display: none;
  background: white;
  border: 1px solid black;
  bottom: 100px;
  flex-direction: column;
  right: 15px;
  border-radius: 3px;
  max-width: $screen;
  margin: auto;

  &.show {
    display: flex;

    &::after {
      content: '';
      display: block;
      position: absolute;
      width: 20px;
      height: 20px;
      background: black;
      transform: rotate(45deg);
      bottom: -10px;
      right: 28px;
    }
  }

  @media (min-width: $screen-tablet) {
    display: block;
    position: relative;
    bottom: 0;
    right: 0;
    border: none;
    line-height: 2.8;
    &.show {
      &::after {
        display: none;
      }
    }
  }
}

.the-header {
  overflow: auto;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10000;

  &.shadow {
    box-shadow: 1px 1px 8px $color-grayscale-300;
  }
}

.header-link.active {
  // text-decoration: underline;
  color: $color-primary-3;
  font-weight: 700;
}

.main-logo {
  height: 60px;
  font-size: 40px;
  font-family: 'Oswald', sans-serif;
  text-transform: uppercase;
  color: black;
  text-align: center;
  margin: 20px 0;
}

a {
  font-family: raleway, sans-serif;
  color: black;
  text-decoration: none;
  padding: 0 10px;
  height: 40px;
  font-size: 14px;
  border-bottom: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: $screen-tablet) {
    display: inline-block;
    border: none;
    display: inline-block;
  }
}

#login-signup-link {
  background: black;
  color: white;

  @media (min-width: $screen-tablet) {
    position: absolute;
    right: 20px;
    top: 4px;
    background: white;
    color: black;
  }
}
</style>
